import styled from 'styled-components'
import useTranslation from '../../../hooks/useTranslation'
import WarehouseSiteDesigner from '../../../components/warehouse/WarehouseSiteDesigner'

const PageWrap = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
`

const Header = styled.div`
    padding: 1rem 1.5rem 0.75rem;
    border-bottom: 1px solid ${p => p.theme.area.lightBorder};
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-shrink: 0;
`

const Title = styled.h2`
    font-size: 1.1rem;
    font-weight: 600;
    color: ${p => p.theme.font.color};
    margin: 0;
`

const Body = styled.div`
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`

function WarehouseSitePage() {
    const { t } = useTranslation()
    return (
        <PageWrap>
            <Header>
                <Title>{t('warehouse.site.title')}</Title>
            </Header>
            <Body>
                <WarehouseSiteDesigner />
            </Body>
        </PageWrap>
    )
}

export default WarehouseSitePage
